import { useBreakpointValue } from "@chakra-ui/react";
import { QuickFactsDesktopCarousel } from "./desktop-carousel";
import { QuickFactsMobileCarousel } from "./mobile-carousel";
import { QuickFactProps } from "./quick-fact";

export interface QuickFactsRendererProps {
  facts: QuickFactProps[];
}

export const QuickFactsRenderer = (props: QuickFactsRendererProps) => {
  const { facts } = props;
  const isMobile = useBreakpointValue(
    { base: true, md: false },
    { fallback: "base" },
  );

  return isMobile ? (
    <QuickFactsMobileCarousel facts={facts} />
  ) : (
    <QuickFactsDesktopCarousel facts={facts} />
  );
};
